import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './Services.css';
import { 
  DevOpsIcon, 
  CloudIcon, 
  ManagedServicesIcon, 
  AISolutions, 
  MobileDevIcon, 
  QualityAssuranceIcon 
} from './icons/ServiceIcons';

const Services = () => {
  const { t, localizedPath } = useLanguage();
  
  const services = [
    {
      icon: <AISolutions size={48} />,
      title: t('services.aiSolutions.title'),
      description: t('services.aiSolutions.description'),
      link: '/services'
    },
    {
      icon: <CloudIcon size={48} />,
      title: t('services.cloudDeployment.title'),
      description: t('services.cloudDeployment.description'),
      link: '/services'
    },
    {
      icon: <MobileDevIcon size={48} />,
      title: t('services.mobileDevelopment.title'),
      description: t('services.mobileDevelopment.description'),
      link: '/services'
    },
    {
      icon: <DevOpsIcon size={48} />,
      title: t('services.devOps.title'),
      description: t('services.devOps.description'),
      link: '/services'
    },
    {
      icon: <ManagedServicesIcon size={48} />,
      title: t('services.managedServices.title'),
      description: t('services.managedServices.description'),
      link: '/services'
    },
    {
      icon: <QualityAssuranceIcon size={48} />,
      title: t('services.qualityAssurance.title'),
      description: t('services.qualityAssurance.description'),
      link: '/services'
    }
  ];

  return (
    <section className="services section">
      <div className="container">
        <h2 className="section-title">{t('services.title')}</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card stagger-${index + 1}`}>
              <div className="service-icon" aria-hidden="true">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <a href={localizedPath('/services')} className="service-link">
                {t('common.readMore')}
                <span className="visually-hidden">: {service.title}</span>
                <span className="link-arrow" aria-hidden="true">→</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
